import { render, staticRenderFns } from "./plain_list.vue?vue&type=template&id=c1797e9e&scoped=true&"
import script from "./plain_list.vue?vue&type=script&lang=js&"
export * from "./plain_list.vue?vue&type=script&lang=js&"
import style0 from "./plain_list.vue?vue&type=style&index=0&id=c1797e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1797e9e",
  null
  
)

export default component.exports